module.exports = __webpack_public_path__ + "img/1.d6794b07.jpg";